import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerPeriodosInformeConservacion = async (values) => {
    try {

        const resultado = await instance.Backend.post("/Autorizacion/ObtenerPeriodosInformeConservacion",values, customConfig);
        
        return resultado

    } 
    catch (error) 
    {
        console.log(error);
    }
}
export { ObtenerPeriodosInformeConservacion };